module.exports = __webpack_public_path__ + "img/8_cover2.be9630df.png";